<template>
  <header class="archive-header">
    <div class="header-content">
      <router-link to="/" class="title-section title-link">
        <h1 class="archive-title"><span class="title-icon">🦋</span> The Ephemera Archive</h1>
        <p class="archive-subtitle">A Museum of Digital Encounters</p>
      </router-link>

      <div class="session-section" v-if="sessionId">
        <div class="session-identity">
          <span class="session-label">Curator ID:</span>
          <code class="session-id">{{ sessionId }}</code>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useArchiveStore } from '../../stores/archive';

const archiveStore = useArchiveStore();

const sessionId = computed(() => archiveStore.sessionId);
</script>

<style scoped>
.archive-header {
  background-color: var(--color-sepia-medium);
  border-bottom: none;
  padding: var(--spacing-md) var(--spacing-xl) var(--spacing-sm);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-lg);
}

.title-section {
  flex: 1;
}

.title-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.title-link:hover .archive-title {
  color: var(--color-burgundy);
}

.title-link:focus {
  outline: 2px solid var(--color-burgundy);
  outline-offset: 4px;
  border-radius: 2px;
}

.archive-title {
  font-size: 2.5rem;
  margin: 0;
  color: var(--color-black-primary);
  font-family: var(--font-serif);
  letter-spacing: -0.02em;
}

.archive-subtitle {
  font-size: 1rem;
  color: var(--color-burgundy);
  margin: var(--spacing-xs) 0 0;
  font-style: italic;
}

.session-section {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.session-identity {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background-color: var(--color-sepia-light);
  border: 1px solid var(--color-black-secondary);
  border-radius: 4px;
}

.session-label {
  font-size: 0.875rem;
  color: var(--color-black-secondary);
  font-weight: 500;
}

.session-id {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 0.875rem;
  color: var(--color-burgundy);
  font-weight: 600;
  letter-spacing: 0.05em;
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .archive-title {
    font-size: 1.75rem;
  }

  .archive-subtitle {
    font-size: 0.875rem;
  }

  .session-section {
    width: 100%;
  }
}
</style>
